import '@/installCompositionApi'
import '@/installFineMq'

import { mountComponentTag } from '@/mounter'

import DotcomTestimonial from './Testimonial'

mountComponentTag('testimonial', DotcomTestimonial)
